import {
  MicroUnits,
  ProductsEditableColumnConfigItem,
} from "../../../MicroAdjustmentsTable/types";

export const ManufacturingTableMetrics: ProductsEditableColumnConfigItem[] = [
  {
    field_key: "electricity",
    label: "micro:manufacturingSection.table.electricityEur",
    defaultUnit: MicroUnits.PERCENTAGE,
  },
  {
    field_key: "pasteurisation",
    label: "micro:manufacturingSection.table.pasteurisationEur",
    defaultUnit: MicroUnits.PERCENTAGE,
  },
  {
    field_key: "steam",
    label: "micro:manufacturingSection.table.steamEur",
    defaultUnit: MicroUnits.PERCENTAGE,
  },
];
